import AboutHero from "../components/AboutPage/AboutHero";
import Achievements from "../components/achievements/Achievements";

const About = () => {
    return(
        <div>
            <AboutHero />
            <Achievements />
        </div>
    );
}

export default About;